
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9JBuG", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $5L3UP = parcelRequire("5L3UP");


var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $2eAN0 = parcelRequire("2eAN0");


var $hareu = parcelRequire("hareu");


var $6Ymez = parcelRequire("6Ymez");


var $bCUcs = parcelRequire("bCUcs");


var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");


var $dAioJ = parcelRequire("dAioJ");


var $72Zuk = parcelRequire("72Zuk");


var $kQMkl = parcelRequire("kQMkl");


var $kFLxH = parcelRequire("kFLxH");


var $2vDkv = parcelRequire("2vDkv");


var $sRb5o = parcelRequire("sRb5o");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bOzDC = parcelRequire("bOzDC");

const $15b3a26189142445$export$c0c8ceeb88dd1e08 = {
    displayName: 'Forge GDrive Eugene Test Staging',
    id: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bOzDC.ForgeGdriveEugeneTestDevIcon), 'ForgeGdriveEugeneTestDev', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bOzDC.ForgeGdriveEugeneTestDevSearchResultIcon), 'ForgeGdriveEugeneTestDev', 'large'),
    integrationAri: 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Project,
            {
                entities3P: (0, $kQMkl.DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Message,
            {
                entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: (0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).PullRequest,
            {
                entities3P: (0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Commit,
            {
                entities3P: (0, $bCUcs.DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Branch,
            {
                entities3P: (0, $6Ymez.DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeGdriveEugeneTestDevConfig"] = $15b3a26189142445$export$c0c8ceeb88dd1e08;

});

parcelRegister("f3t7x", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $353cafebfceb5684$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $353cafebfceb5684$export$733c2acb2513a07a;

});

parcelRegister("4moZS", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4dabbc53c19f0eb6$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $4dabbc53c19f0eb6$export$4e0eae9edc1a8907;

});

parcelRegister("6GYKu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $76ad9eb563127536$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $76ad9eb563127536$export$a752b216a5b9069f;

});

parcelRegister("5L3UP", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c71c6856c01ed4e1$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $c71c6856c01ed4e1$export$8dd471de1c2be682;

});

parcelRegister("lSV0R", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $73e7c9ae902307cd$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $73e7c9ae902307cd$export$5794851cbc8ee193;

});

parcelRegister("5zhyH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c56574206e5d9432$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $c56574206e5d9432$export$f752f74515f17189;

});

parcelRegister("2eAN0", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $985674bff788ed13$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $985674bff788ed13$export$13c55dcee8605c46;

});

parcelRegister("hareu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $572397f4f72859d8$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $572397f4f72859d8$export$9d37c36d8b43baee;

});

parcelRegister("6Ymez", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $0aab066f73937fd8$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $0aab066f73937fd8$export$7bf025ec33e76761;

});

parcelRegister("bCUcs", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ea564ddf0cc8c2fd$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $ea564ddf0cc8c2fd$export$3e5409bef2addb56;

});

parcelRegister("fmJYG", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $51acdb1b50e4834b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $51acdb1b50e4834b$export$3268f1527392e5ac;

});

parcelRegister("iM9d2", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fe7cd180c5f0ee38$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fe7cd180c5f0ee38$export$c28231fcae6448eb;

});

parcelRegister("dAioJ", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ac1d391d64bfedde$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $ac1d391d64bfedde$export$d520529b4595d46c;

});

parcelRegister("72Zuk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $229f506edf3bbbcc$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $229f506edf3bbbcc$export$8bd7fa13a82672fe;

});

parcelRegister("kQMkl", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $58e4cb80d7bd8f2a$export$3f89e5cd56d4a568 = [
    'ati:cloud:graph:project'
];
module.exports["DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI"] = $58e4cb80d7bd8f2a$export$3f89e5cd56d4a568;

});

parcelRegister("kFLxH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cd2849e7738ca37b$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $cd2849e7738ca37b$export$1dc2d469fb044d48;

});

parcelRegister("2vDkv", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $b3506739b3db16a9$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $b3506739b3db16a9$export$1e3b02869b42f77a;

});

parcelRegister("sRb5o", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cedd31adddcd6a4e$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $cedd31adddcd6a4e$export$a3d7cddace4fe237;

});

parcelRegister("2Rsot", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a989069c3574d0d8$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $a989069c3574d0d8$export$d810eae89914369b;

});

parcelRegister("bOzDC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bS2kQ")).then((m)=>m.ForgeGdriveEugeneTestDevIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/icon'
});

const $0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bS2kQ")).then((m)=>m.ForgeGdriveEugeneTestDevSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/search-result-icon'
});
const $0812653a4f5fcb19$export$d25ddeed4ba7332 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevIconComponent, null));
const $0812653a4f5fcb19$export$5a35b3e4364deaaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0812653a4f5fcb19$var$LazyForgeGdriveEugeneTestDevSearchResultIconComponent, null));
module.exports["ForgeGdriveEugeneTestDevIcon"] = $0812653a4f5fcb19$export$d25ddeed4ba7332;
module.exports["ForgeGdriveEugeneTestDevSearchResultIcon"] = $0812653a4f5fcb19$export$5a35b3e4364deaaf;

});

parcelRegister("bS2kQ", function(module, exports) {

let $8a468c9a4cc1fd6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a468c9a4cc1fd6d$var$load("7XbUL").then(()=>parcelRequire('37RNC'));

});


//# sourceMappingURL=forge-gdrive-eugene-test-dev.23bafc05.js.map
